export default __webpack_public_path__ + "static/media/location.1e857c15.svg";